import React, { useState } from "react";

function EditPlayerModal({ player, clubs, onSubmit, onClose }) {
  const [editedPlayer, setEditedPlayer] = useState({
    ...player,
    profileImageFile: null,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, editedPlayer);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-surface-800 border border-line-strong rounded-xl w-full max-w-2xl">
        <h2 className="text-xl font-semibold mb-4">Edit Player</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 flex items-center space-x-4">
              <img
                src={player.profileImageUrl}
                alt={`${player.name}'s profile`}
                className="h-20 w-20 rounded-full object-cover"
              />
              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setEditedPlayer({
                    ...editedPlayer,
                    profileImageFile: e.target.files[0],
                  })
                }
                className="bg-surface-700 p-2 rounded flex-1"
              />
            </div>
            <input
              type="text"
              className="bg-surface-700 p-2 rounded"
              value={editedPlayer.name}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, name: e.target.value })
              }
              placeholder="Name"
            />
            <select
              className="bg-surface-700 p-2 rounded"
              value={editedPlayer.clubId || ""}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, clubId: e.target.value })
              }
            >
              <option value="">Select Club</option>
              {clubs.map((club) => (
                <option key={club.clubId} value={club.clubId}>
                  {club.name}
                </option>
              ))}
            </select>
            <input
              type="text"
              className="bg-surface-700 p-2 rounded"
              value={editedPlayer.position}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, position: e.target.value })
              }
              placeholder="Position"
            />
            <input
              type="number"
              className="bg-surface-700 p-2 rounded"
              value={editedPlayer.age}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, age: e.target.value })
              }
              placeholder="Age"
            />
            <select
              className="bg-surface-700 p-2 rounded"
              value={editedPlayer.preferredLeg || ""}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, preferredLeg: e.target.value })
              }
            >
              <option value="">Select Preferred Leg</option>
              <option value="left">Left</option>
              <option value="right">Right</option>
            </select>
            <textarea
              className="bg-surface-700 p-2 rounded col-span-2"
              value={editedPlayer.bio}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, bio: e.target.value })
              }
              placeholder="Bio"
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-surface-600 px-4 py-2 rounded hover:bg-surface-700"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-accent px-4 py-2 rounded hover:bg-accent-hover"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditPlayerModal;
